import ClassNames from "classnames";
import { FunctionComponent } from "react";
import { style } from "typestyle";
import { ColorScheme, TitleAndSubtitleTextAlign } from "../types/index.js";
import MultilineText from "./MultilineText.js";

interface Props {
  isFirstOnPage: boolean;
  textAlign: TitleAndSubtitleTextAlign;
  className?: string;
  title: string;
  subtitle: string | undefined;
  scheme: ColorScheme;
}

const ModuleHeadings: FunctionComponent<Props> = ({
  isFirstOnPage,
  className,
  textAlign,
  title,
  subtitle,
  scheme,
}) => {
  const TagName = isFirstOnPage ? "h1" : "h2";
  const SubtitleTagName = title ? "div" : TagName;
  if (!title && !subtitle) return null;
  return (
    <div className="Module__Headings">
      {title && (
        <TagName
          className={ClassNames(
            "Module__Title",
            `TextAlign--${textAlign.title}`,
            className,
            style({ color: scheme.main.title }),
          )}
        >
          {title}
        </TagName>
      )}
      {subtitle && (
        <SubtitleTagName
          className={ClassNames(
            "Module__Subtitle",
            `TextAlign--${textAlign.subtitle}`,
            style({ color: scheme.main.text }),
          )}
        >
          <MultilineText text={subtitle} />
        </SubtitleTagName>
      )}
    </div>
  );
};

export default ModuleHeadings;
